// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MapLocation: React.FC = () => {
    return(
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 32 29"  
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            focusable="false" 
            width="24" 
            height="24" 
            fill="currentColor"
        >
            <path 
                d="M16 .5a6.666 6.666 0 00-6.667 6.667c0 2.687.937 3.439 5.984 10.75a.833.833 0 001.37 0c5.04-7.311 5.98-8.061 5.98-10.75A6.666 6.666 0 0016 .5zm0 9.778a2.667 2.667 0 010-5.334 2.67 2.67 0 012.667 2.667A2.668 2.668 0 0116 10.278zM.559 13.144a.885.885 0 00-.559.823V28.05a.891.891 0 001.222.824L8.89 25.39v-13.7c-.417-.7-.711-1.3-.922-1.883L.559 13.144zm17.585 5.79a2.612 2.612 0 01-4.292-.005c-.896-1.301-2.913-4.173-3.185-4.562v10.972l10.666 3.605V14.367c-.272.389-2.289 3.26-3.189 4.566zm12.64-9.478l-7.673 3.488v16l8.328-3.755c.339-.183.561-.461.561-.822v-14.09c0-.627-.633-1.105-1.217-.821z"
            />
        </svg>
    );
};

export default React.memo(MapLocation);

